window.addEventListener("load", function() {
    $(".btn__scrollFrame").on('click', function(e) {
        const frame = $(this).data('frame');
        e.preventDefault();
        if (!frame) return;
        $(frame).trigger('click');
    });

});